<template>
	<div class="socialintell">
		
		<headerview :cur="5"></headerview>
		<div class="content">
			
			<div class="moddlecon w13">
				<div class="tipcon">
					<tipcon :title="'社会情报站'" :name="'红领巾通讯社>社会情报站'" :imgtype="'3'" width="2.6"></tipcon>
				</div>
				
				<div class="listcon_public min-h">
					<div class="signle" v-for="(item,index) in list" :key="index" @click="seedetail(item)">
						<div class="title" :title="item.title">{{item.title || ''}}</div>
						<div class="time">{{item.pubTime?item.pubTime.split(' ')[0]:''}}</div>
					</div>
				</div>
				
				<!-- 分页 -->
				<div class="">
					<div is='footPage' class="zhini-pagination"
					  :currentPage="pageNo"
					  :totalPage="total"
					  @pageNum="pageNum"  :pagesize='pageSize'></div>
				</div>
				
			</div>
				
		</div>		
				
		<footview></footview>
		
	</div>
	
</template>

<script>

import tipcon from "../../../com/tipcon.vue";
import footPage from '../../../components/footpage/footpage.vue'
export default {
  components: {
  	  tipcon,
	  footPage,
  },
   
  data: function() {
    return {
		list:[],
		pageNo:1,
		total:5,
		pageSize:5,
	  
    };
  },
  
  mounted() {
		this.$onScrollT()
		this.getSocial()
  },

  methods: {
	    //社会情报站
	    getSocial(){
	    	this.$get(`web/info/society?pageSize=8&pageNo=${this.pageNo}`).then(res=>{
	    		  if(res.success){
	    				this.total = res.result.total
	    				this.list = res.result.records
	    		  }
	    	})
	    },
	  
	    //跳转详情
		seedetail(item){
			this.$router.push({ path: '/textdetail?id='+item.id +'&type=3'});			
		},
		
		pageNum(e) {
			this.pageNo = e;
			this.$onScrollT()
			this.getSocial();
		},
		
		
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.socialintell{
	
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
			padding: 20px 50px 0px 50px;
			box-sizing: border-box;
						
		}
			
	}
			
			
	
}

</style>
